import { useSimilarDiamondData } from "@apis/diamondDetail";
import { ProductCategory } from "@utils/constants";
import {
  isDiamondOrLabGrown,
  isLabGrown,
} from "@utils/product/productValidators";

interface UsePdpSimilarProductsProps {
  route: any;
  isModal: boolean;
  product_type: ProductCategory;
  priceMode: number;
  priceMarkup: number;
  userInfo: any;
  mGroupIds: any;
  findMatchSectionLayout: any;
}

export const usePdpSimilarProducts = ({
  route,
  isModal,
  product_type,
  priceMode,
  priceMarkup,
  userInfo,
  mGroupIds,
  findMatchSectionLayout,
}: UsePdpSimilarProductsProps) => {
  const getMatchPairDetailData = useSimilarDiamondData(
    Number(route?.params?.productID) as number,
    userInfo,
    priceMode,
    priceMarkup,
    false,
    0,
    isLabGrown(product_type),
    isDiamondOrLabGrown(product_type) &&
      !isModal &&
      !Array.isArray(findMatchSectionLayout) &&
      Object.keys(findMatchSectionLayout).length > 0 &&
      findMatchSectionLayout?.price_modes?.includes(priceMode),
    mGroupIds
  );

  return {
    getMatchPairDetailData,
  };
};
